"use client"

import { SDKProvider } from "@letterhead/core/react"
import { SubscribeForm } from "@/components/subscribe-form"

export default function SubscribePage() {
  // Configure the SDK
  const sdkConfig = {
    apiUrl: process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8080",
    organizationId: process.env.NEXT_PUBLIC_ORG_ID ?? "",
    apiKey: process.env.NEXT_PUBLIC_LETTERHEAD_API,
  }

  return (
    <SDKProvider config={sdkConfig}>
      <div className="container mx-auto py-12 px-4">
        <div className="max-w-4xl mx-auto space-y-12">
          {/* Page Header */}
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold">
              Get the intelligence that moves before the ground does
            </h1>
            <p className="text-lg text-muted-foreground">
              Monthly briefs on field data, mapping innovation, and the trends
              shaping decisions across Africa&apos;s energy, infrastructure,
              and logistics sectors.
            </p>
          </div>

          {/* Subscribe Form */}
          <div className="max-w-md mx-auto">
            <SubscribeForm
              title="Get the next brief in your inbox"
              description="One email a month. Built for the people making decisions on the ground."
              tags={["newsletter"]}
              source="website-subscribe-page"
            />
          </div>
        </div>
      </div>
    </SDKProvider>
  )
}